import { useEffect } from "react";
import { QuickNoteContainer } from "../common/QuickNoteContainer";
import "../styles/_quickNoteComponent.scss";

const OverviewComponent = ({ allDataLoading, setIsVisible, handleDeletePopupClick, openModal, isForEmploymentDetails }: any) => {
  const handleAddEditQuickNote = () => {
    setIsVisible(true);
  };
  useEffect(() => {
    return () => {
      setIsVisible(false);
    };
  }, []);

  return (
    <>
      <QuickNoteContainer
        openModal={openModal}
        handleAddEditQuickNote={handleAddEditQuickNote}
        handleDeleteQuickNote={handleDeletePopupClick}
        allDataLoading={allDataLoading}
        quickNoteContainerClass="quick-note-container"
        quickNotesListContainerClass="quick-note-list-container"
        isForEmploymentDetails={isForEmploymentDetails}
      />
    </>
  );
};

export default OverviewComponent;
